import type { ReactElement, SVGProps } from "react";

/** Fireworks (open-model lane) — the official Fireworks AI mark, white on the
 *  violet brand tile. */
export function FireworksLogo(props: SVGProps<SVGSVGElement>): ReactElement {
  return (
    <svg
      width={16}
      height={16}
      viewBox="0 0 24 24"
      fill="#ffffff"
      fillRule="evenodd"
      aria-hidden
      {...props}
    >
      <path
        clipRule="evenodd"
        d="M14.8 5l-2.801 6.795L9.195 5H7.397l3.072 7.428a1.64 1.64 0 003.038.002L16.598 5H14.8zm1.196 10.352l5.124-5.244-.699-1.669-5.596 5.739a1.664 1.664 0 00-.343 1.807 1.642 1.642 0 001.516 1.012L16 17l8-.02-.699-1.669-7.303.041h-.002zM2.88 10.104l.699-1.669 5.596 5.739c.468.479.603 1.189.343 1.807a1.643 1.643 0 01-1.516 1.012l-8-.018-.002.002.699-1.669 7.303.042-5.122-5.246z"
      />
    </svg>
  );
}
